function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 1l20.422 6.127c2.85.855 2.85 4.891 0 5.747l-14.037 4.21c-1.9.57-1.9 3.262 0 3.832l14.037 4.21c2.85.856 2.85 4.892 0 5.747L7.386 35.084c-1.9.57-1.9 3.261 0 3.832l14.036 4.21c2.85.856 2.85 4.892 0 5.748L1 55",
  stroke: "#1A1A1A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 1l20.422 6.127c2.85.855 2.85 4.891 0 5.747l-14.036 4.21c-1.9.57-1.9 3.262 0 3.832l14.036 4.21c2.85.856 2.85 4.892 0 5.747l-14.036 4.211c-1.9.57-1.9 3.261 0 3.832l14.036 4.21c2.85.856 2.85 4.892 0 5.748L21 55",
  stroke: "#1A1A1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41 1l20.422 6.127c2.85.855 2.85 4.891 0 5.747l-14.036 4.21c-1.9.57-1.9 3.262 0 3.832l14.036 4.21c2.85.856 2.85 4.892 0 5.747l-14.036 4.211c-1.9.57-1.9 3.261 0 3.832l14.036 4.21c2.85.856 2.85 4.892 0 5.748L41 55",
  stroke: "#1A1A1A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61 1l20.422 6.127c2.85.855 2.85 4.891 0 5.747l-14.037 4.21c-1.9.57-1.9 3.262 0 3.832l14.037 4.21c2.85.856 2.85 4.892 0 5.747l-14.036 4.211c-1.9.57-1.9 3.261 0 3.832l14.036 4.21c2.85.856 2.85 4.892 0 5.748L61 55",
  stroke: "#1A1A1A"
});

function SvgTickerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 56,
    viewBox: "0 0 91 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgTickerinline;